import React from 'react';
import {
  CheckCircle2, AlertTriangle, Ship, Receipt, FolderOpen,
  PoundSterling, CalendarDays, Clock, TrendingUp,
} from 'lucide-react';

export const ReportStats = ({ stats, expensesSummary, documentsCount }) => (
  <>
    {/* Key Stats */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700/50">
        <div className="flex items-center gap-2 text-slate-400 text-xs mb-1">
          <PoundSterling className="h-3.5 w-3.5" />
          Total Earnings
        </div>
        <p className="text-2xl font-bold text-white">£{stats.total_earnings?.toLocaleString()}</p>
      </div>
      <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700/50">
        <div className="flex items-center gap-2 text-slate-400 text-xs mb-1">
          <CalendarDays className="h-3.5 w-3.5" />
          Qualifying Days
        </div>
        <p className="text-2xl font-bold text-white">{stats.qualifying_days}</p>
      </div>
    </div>

    {/* SED Status */}
    <div className={`rounded-lg p-4 border flex items-center gap-3 ${
      stats.claim_broken
        ? 'bg-red-500/10 border-red-500/30'
        : stats.sed_eligible
          ? 'bg-emerald-500/10 border-emerald-500/30'
          : 'bg-amber-500/10 border-amber-500/30'
    }`}>
      {stats.claim_broken ? (
        <AlertTriangle className="h-5 w-5 text-red-400" />
      ) : stats.sed_eligible ? (
        <CheckCircle2 className="h-5 w-5 text-emerald-400" />
      ) : (
        <TrendingUp className="h-5 w-5 text-amber-400" />
      )}
      <div>
        <p className={`font-semibold ${
          stats.claim_broken ? 'text-red-400' : stats.sed_eligible ? 'text-emerald-400' : 'text-amber-400'
        }`}>
          SED Status: {stats.claim_broken ? 'Claim Broken' : stats.sed_eligible ? 'Eligible' : 'Building Eligibility'}
        </p>
        <p className="text-xs text-slate-400 mt-0.5">
          {stats.days_in_hand} days in hand | Max consecutive UK: {stats.max_consecutive_uk_days} days
        </p>
      </div>
    </div>

    {/* Additional Stats */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
      <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50 min-w-0">
        <div className="flex items-center gap-2 text-slate-400 mb-1">
          <Ship className="h-4 w-4" />
          <span className="text-xs">Trips</span>
        </div>
        <p className="text-lg font-bold text-white">{stats.trips_count}</p>
      </div>
      <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
        <div className="flex items-center gap-2 text-slate-400 mb-1">
          <Clock className="h-4 w-4" />
          <span className="text-xs">Max UK Days</span>
        </div>
        <p className={`text-lg font-bold ${stats.max_consecutive_uk_days > 150 ? 'text-amber-400' : 'text-white'}`}>
          {stats.max_consecutive_uk_days}
        </p>
      </div>
      <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
        <div className="flex items-center gap-2 text-slate-400 mb-1">
          <Receipt className="h-4 w-4" />
          <span className="text-xs">Expenses</span>
        </div>
        <p className="text-lg font-bold text-white">
          £{(expensesSummary.total_tax_deductible || 0).toLocaleString()}
        </p>
      </div>
      <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700/50">
        <div className="flex items-center gap-2 text-slate-400 mb-1">
          <FolderOpen className="h-4 w-4" />
          <span className="text-xs">Documents</span>
        </div>
        <p className="text-lg font-bold text-white">{documentsCount}</p>
      </div>
    </div>
  </>
);
